/*
 * Copyright (c) 2025 curryfirm.com
 */

// hooks/useAuth.js

import { useEffect, useState, useContext, createContext } from 'react';
import { auth } from '../services/firebase.js';
import { onAuthStateChanged } from 'firebase/auth';

const AuthContext = createContext();

// AuthProvider wraps your app in index.js
export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [authChecked, setAuthChecked] = useState(false);

    useEffect(() => {
        return onAuthStateChanged(auth, (firebaseUser) => {
            setUser(firebaseUser);
            setAuthChecked(true);
        });
    }, []);

    return (
        <AuthContext.Provider value={{ user, authChecked }}>
            {children}
        </AuthContext.Provider>
    );
}

// This hook can be used in any component for easy access
export function useAuth() {
    return useContext(AuthContext);
}
